import { useCallback, useState, useRef } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { ConversationHistoryService } from '../../services/conversationHistoryService';
import { Conversation } from '../types/Conversation';
import { showToast } from '../utils/toast';

export const useConversationList = (initialLimit = 20) => {
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const offsetRef = useRef(0);
  const authenticatedFetch = useAuthenticatedFetch();

  const loadConversations = useCallback(
    async (isLoadMore = false) => {
      setLoading(true);
      try {
        const currentOffset = isLoadMore ? offsetRef.current + initialLimit : 0;
        const response = await ConversationHistoryService.listConversations(
          authenticatedFetch,
          initialLimit,
          currentOffset
        );

        if (isLoadMore) {
          setConversations((prev) => [...prev, ...response.conversations]);
        } else {
          setConversations(response.conversations);
        }

        setTotal(response.total);
        offsetRef.current = currentOffset;
      } catch (err) {
        if (err instanceof Error) {
          showToast(err.message, 'error');
        } else {
          showToast('Une erreur est survenue lors du chargement des conversations', 'error');
        }
      } finally {
        setLoading(false);
      }
    },
    [authenticatedFetch, initialLimit]
  );

  const hasMore = conversations.length < total;

  return {
    conversations,
    loading,
    total,
    hasMore,
    loadConversations,
  };
};
